import BreadCrump from "../tools/breadcrump"
import { getCookies } from "cookies-next";
import { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { config } from "../../data/config";
import { useTranslation } from 'react-i18next';
import HeaderOfPage from "../tools/headerOfPage";
import { useNavigate } from 'react-router-dom';

export default function ListTestimonialGroup() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Testimonial',
            url: '/dashboard/Testimonial'
        },
        {
            name: 'Group List',
            url: null
        },
    ]
    const reloadgame = () => {
        let x = key + 1;
        setKey(x);
    }
    const [key, setKey] = useState(1);

    return (
        <>
            <div className="bg-gray-50 min-h-screen p-4 md:p-6">
                <BreadCrump data={breadcrump}></BreadCrump>
                <HeaderOfPage name="Testimonial Group List"></HeaderOfPage>

                <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mt-6">
                    <div className="lg:col-span-1" dir="rtl">
                        <NewTestimonialGroup reloaditem={reloadgame} key={key}></NewTestimonialGroup>
                    </div>
                    <div className="lg:col-span-3">
                        <ListofTestimonialGroup key={key}></ListofTestimonialGroup>
                    </div>
                </div>
            </div>
        </>
    )
}

function ListofTestimonialGroup() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    let cookie = getCookies();
    const [list, setList] = useState<any>(null);
    const [error, setError] = useState<any>(null);
    const [key, setKey] = useState<any>(1);
    const [loading, setLoading] = useState<boolean>(true);
    
    // Language selector state - default to Persian (fa)
    const [languages, setLanguages] = useState<Array<{ code: string; label: string }>>([]);
    const [activeLang, setActiveLang] = useState<string>('fa'); // Default to Persian
    
    // Load languages
    const loadLanguages = async () => {
        try {
            const res = await axios.get(`${config.url}/v1/language`);
            const languageList = res.data?.message ?? [];
            const mapped = languageList
                .filter((lang: any) => lang.active)
                .sort((a: any, b: any) => (a.arranged ?? 0) - (b.arranged ?? 0))
                .map((lang: any) => ({ code: lang.code, label: lang.label }));
            setLanguages(mapped);
            // Set default to Persian if available, otherwise first language
            const faLang = mapped.find((l: { code: string; label: string }) => l.code === 'fa');
            if (faLang) {
                setActiveLang('fa');
            } else if (mapped.length > 0) {
                setActiveLang(mapped[0].code);
            }
        } catch (e) {
            console.error('Error loading languages:', e);
            const fallback = [
                { code: 'ku', label: 'Kurdish' },
                { code: 'fa', label: 'فارسی' },
                { code: 'en', label: 'English' },
                { code: 'ar', label: 'العربية' },
                { code: 'tr', label: 'Türkçe' }
            ];
            setLanguages(fallback);
            setActiveLang('fa');
        }
    };
    
    // Helper function to get multilingual value
    const getMultilingualValue = (field: any, lang: string): string => {
        if (!field) return '';
        if (typeof field === 'string') return field;
        if (typeof field === 'object') {
            return field[lang] || field.en || field.fa || field.ku || field.ar || field.tr || '';
        }
        return '';
    };

    const getalldata = async () => {
        setError(null);
        setLoading(true);

        try {
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/testimonialgroup',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            setList(res.data.message.docs || res.data.message);
        } catch (error: any) {
            setError(error.response?.data?.message || t('Error loading groups'));
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: error.response?.data?.message || t('Error loading groups'),
            });
        } finally {
            setLoading(false);
        }
    }
    
    const deleted = async (id: any) => {
        Swal.fire({
            title: t("Are you sure?"),
            text: t("Delete this Group!"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t("Yes, delete it!"),
            cancelButtonText: t('Cancel')
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    let res = await axios({
                        method: 'delete',
                        url: config.url + '/v1/dashboard/testimonialgroup/' + id,
                        headers: {
                            Authorization: 'Bearer ' + cookie['token'],
                        }
                    })

                    Swal.fire({
                        icon: 'success',
                        title: t('Deleted'),
                        text: t('Group deleted successfully'),
                        timer: 1500,
                        showConfirmButton: false
                    });

                    getalldata();
                } catch (error: any) {
                    Swal.fire({
                        icon: 'error',
                        title: t('Error'),
                        text: error.response?.data?.message || t('Error deleting group'),
                    });
                }
            }
        });
    }
    
    useEffect(() => {
        loadLanguages();
        getalldata();
    }, []);

    if (loading && !list) {
        return (
            <div className="bg-white rounded-xl shadow-sm p-8">
                <div className="flex items-center justify-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                </div>
                <p className="text-center mt-4 text-gray-600">در حال بارگذاری...</p>
            </div>
        );
    }

    const displayList = Array.isArray(list) ? list : (list?.docs || []);
    const langList = languages.length > 0 ? languages : [
        { code: 'ku', label: 'Kurdish' },
        { code: 'fa', label: 'فارسی' },
        { code: 'en', label: 'English' },
        { code: 'ar', label: 'العربية' },
        { code: 'tr', label: 'Türkçe' }
    ];

    return (
        <div className="space-y-4" dir="rtl">
            <div className="bg-white rounded-xl shadow-sm p-4">
                <div className="flex items-center justify-between flex-wrap gap-4">
                    <div className="flex items-center gap-3">
                        <button
                            type="button"
                            onClick={() => getalldata()}
                            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                        >
                            <div className="flex items-center gap-2">
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                </svg>
                                {t('Reload')}
                            </div>
                        </button>
                    </div>
                    {/* Language Selector */}
                    <div className="flex items-center gap-2">
                        <span className="text-sm font-medium text-gray-700">زبان:</span>
                        <div className="flex gap-2 flex-wrap">
                            {langList.map((lang) => (
                                <button
                                    key={lang.code}
                                    type="button"
                                    onClick={() => setActiveLang(lang.code)}
                                    className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${
                                        activeLang === lang.code
                                            ? 'bg-blue-600 text-white'
                                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                    }`}
                                >
                                    {lang.label}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                {error && (
                    <div className="p-4 bg-red-50 border-r-4 border-red-500 text-red-700">
                        {error}
                    </div>
                )}
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th scope="col" className="px-6 py-4 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    {t('Title')}
                                </th>
                                <th scope="col" className="px-6 py-4 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    {t('Description')}
                                </th>
                                <th scope="col" className="px-6 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    {t('Action')}
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {displayList && displayList.length > 0 ? (
                                displayList.map((item: any) => {
                                    const displayTitle = getMultilingualValue(item.title, activeLang);
                                    const displayDescription = getMultilingualValue(item.description, activeLang);
                                    return (
                                        <tr key={item._id || item.id} className="hover:bg-gray-50">
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm font-medium text-gray-900">{displayTitle || '-'}</div>
                                            </td>
                                            <td className="px-6 py-4">
                                                <div className="text-sm text-gray-500 line-clamp-2">{displayDescription || '-'}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                                                <div className="flex items-center justify-center gap-2">
                                                    <button
                                                        onClick={() => navigate(`/dashboard/Testimonial/GroupEdit/${item._id || item.id}`)}
                                                        className="text-blue-600 hover:text-blue-900 px-3 py-1 rounded hover:bg-blue-50"
                                                    >
                                                        {t('Edit')}
                                                    </button>
                                                    <button
                                                        onClick={() => navigate(`/dashboard/Testimonial/Details/${item._id || item.id}`)}
                                                        className="text-green-600 hover:text-green-900 px-3 py-1 rounded hover:bg-green-50"
                                                    >
                                                        {t('Details')}
                                                    </button>
                                                    <button
                                                        onClick={() => deleted(item._id || item.id)}
                                                        className="text-red-600 hover:text-red-900 px-3 py-1 rounded hover:bg-red-50"
                                                    >
                                                        {t('Delete')}
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan={3} className="px-6 py-4 text-center text-sm text-gray-500">
                                        {t('No groups found')}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

function NewTestimonialGroup({ reloaditem }: any) {
    const { t } = useTranslation();
    let cookie = getCookies();
    const [activeLang, setActiveLang] = useState<string>('fa'); // Default to Persian
    const [languages, setLanguages] = useState<Array<{ code: string; label: string }>>([]);

    const [data, setData] = useState<any>({
        title: {},
        description: {}
    });
    const [saving, setSaving] = useState(false);

    const inputstyle = "py-3 px-5 block w-full border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:pointer-events-none bg-white text-gray-900";

    // Load languages
    const loadLanguages = async (): Promise<Array<{ code: string; label: string }>> => {
        try {
            const res = await axios.get(`${config.url}/v1/language`);
            const languageList = res.data.message || [];
            const mappedLanguages = languageList
                .filter((lang: any) => lang.active)
                .sort((a: any, b: any) => (a.arranged || 0) - (b.arranged || 0))
                .map((lang: any) => ({
                    code: lang.code,
                    label: lang.label
                }));
            setLanguages(mappedLanguages);
            // Set default to Persian if available, otherwise first language
            const faLang = mappedLanguages.find((l: { code: string; label: string }) => l.code === 'fa');
            if (faLang) {
                setActiveLang('fa');
            } else if (mappedLanguages.length > 0) {
                setActiveLang(mappedLanguages[0].code);
            }
            return mappedLanguages;
        } catch (error) {
            console.error('Error loading languages:', error);
            const fallbackLanguages = [
                { code: 'ku', label: 'Kurdish' },
                { code: 'fa', label: 'فارسی' },
                { code: 'en', label: 'English' },
                { code: 'ar', label: 'العربية' },
                { code: 'tr', label: 'Türkçe' }
            ];
            setLanguages(fallbackLanguages);
            setActiveLang('fa'); // Default to Persian in fallback
            return fallbackLanguages;
        }
    };

    // Helper function to initialize multilingual field
    const initializeMultilingualField = (field: any, languageCodes: string[]): any => {
        if (!field) {
            const obj: any = {};
            languageCodes.forEach(code => obj[code] = '');
            return obj;
        }
        if (typeof field === 'string') {
            const obj: any = {};
            languageCodes.forEach(code => obj[code] = field);
            return obj;
        }
        if (typeof field === 'object') {
            const obj: any = { ...field };
            languageCodes.forEach(code => {
                if (!obj[code]) obj[code] = '';
            });
            return obj;
        }
        const obj: any = {};
        languageCodes.forEach(code => obj[code] = '');
        return obj;
    };

    const getMultilingualValue = (field: any, lang: string): string => {
        if (!field) return '';
        if (typeof field === 'string') return field;
        if (typeof field === 'object') {
            return field[lang] || '';
        }
        return '';
    };

    const save = async () => {
        const languageCodes = languages.length > 0 ? languages.map(l => l.code) : ['ku', 'fa', 'en', 'ar', 'tr'];
        const hasTitle = languageCodes.some(code => data.title[code]);
        if (!hasTitle) {
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: t('Title is required in at least one language'),
            });
            return;
        }

        setSaving(true);
        try {
            let res = await axios({
                method: 'post',
                data: data,
                url: config.url + '/v1/dashboard/testimonialgroup',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            Swal.fire({
                icon: 'success',
                title: t('Success'),
                text: t('Group created successfully'),
                timer: 1500,
                showConfirmButton: false
            });
            const emptyMultilingualField: any = {};
            languageCodes.forEach(code => emptyMultilingualField[code] = '');
            setData({
                title: { ...emptyMultilingualField },
                description: { ...emptyMultilingualField }
            });
            reloaditem();
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: error.response?.data?.message || t('Error creating group'),
            });
        } finally {
            setSaving(false);
        }
    }

    useEffect(() => {
        loadLanguages();
    }, []);

    return (
        <div className="bg-white rounded-xl shadow-sm p-6" dir="rtl">
            <h2 className="text-lg font-bold text-gray-800 mb-4">{t('New Testimonial Group')}</h2>
            <form className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t('Language')}
                    </label>
                    <div className="flex gap-2 flex-wrap">
                        {languages.map((lang) => (
                            <button
                                key={lang.code}
                                type="button"
                                onClick={() => setActiveLang(lang.code)}
                                className={`px-3 py-1.5 text-xs font-medium rounded-lg transition-colors ${
                                    activeLang === lang.code
                                        ? 'bg-blue-600 text-white'
                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                }`}
                            >
                                {lang.label}
                            </button>
                        ))}
                    </div>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t('Title')} ({languages.find(l => l.code === activeLang)?.label}) <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        value={getMultilingualValue(data.title, activeLang)}
                        className={inputstyle}
                        placeholder={t('Enter title')}
                        onChange={(e) => setData({
                            ...data,
                            title: {
                                ...data.title,
                                [activeLang]: e.target.value
                            }
                        })}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t('Description')} ({languages.find(l => l.code === activeLang)?.label})
                    </label>
                    <textarea
                        value={getMultilingualValue(data.description, activeLang)}
                        rows={4}
                        className={inputstyle}
                        placeholder={t('Enter description')}
                        onChange={(e) => setData({
                            ...data,
                            description: {
                                ...data.description,
                                [activeLang]: e.target.value
                            }
                        })}
                    />
                </div>

                <button
                    type="button"
                    onClick={save}
                    disabled={saving}
                    className="w-full px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                    {saving ? t('Saving...') : t('Save')}
                </button>
            </form>
        </div>
    );
}

